import React from 'react';
import { func, object, oneOfType } from 'prop-types';

import AlertProvider from '@/context/alert';
import useAuth from './useAuth';

const FirstRoute = ({ component: Component, ...rest }) => {
  useAuth();

  return (
    <AlertProvider>
      <div style={{ height: '100%' }}>
        <Component {...rest} />
      </div>
    </AlertProvider>
  );
};

FirstRoute.propTypes = {
  component: oneOfType([object, func]),
};

FirstRoute.defaultProps = {
  component: null,
};

export default FirstRoute;
